import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AvatarState {
    name: string;
    gender: string;
    brainId: string;
}
  
  const initialState: AvatarState = {
    name: '',
    gender: '',
    brainId: '',
  };

const avatar = createSlice({
  name: 'avatar',
  initialState,
  reducers: {
    setAvatar: (state, action: PayloadAction<AvatarState>) => {
        state.name = action.payload.name;
        state.gender = action.payload.gender;
        if (state.brainId !== action.payload.brainId) {
            state.brainId = action.payload.brainId
        }
    },
    setBrainId: (state, action: PayloadAction<string>) => {
        state.brainId = action.payload;
    },
  },
});

export const { setAvatar, setBrainId } = avatar.actions;
export const avatarReducer = avatar.reducer;